import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import FormLabel from '@material-ui/core/FormLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
// import config from 'config';
// material ui icons
// import Check from "@material-ui/icons/Check";
import PreviewVideo from "components/CustomUpload/PreviewVideo.jsx";

import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import Close from '@material-ui/icons/Close';
// import * as moment from 'moment';
import moment from "moment-timezone";
// import Switch from '@material-ui/core/Switch';
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardText from 'components/Card/CardText.jsx';
// import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';

import TagsInput from "react-tagsinput";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel"
import Datetime from "react-datetime";

import CardIcon from "components/Card/CardIcon.jsx";
import BurstModeIcon from '@material-ui/icons/BurstMode';
import VideoCallIcon from '@material-ui/icons/VideoCall';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Swal from 'sweetalert2';
// style for this view
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import config from 'config';
import DropZone from '../../components/DropZone';
import Loader from '../../components/Loader/LoaderView';

const styles = {
  gridList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  ...sweetAlertStyle,
  ...extendedFormsStyle,
  ...validationFormsStyle,
};

export const dropZoneVideoOption = {
  acceptFile: '.mp4,.mkv,.mpg',
  maxSize: 200,
  limitationText:
    'สามารถอัพโหลดไฟล์นามสกุล (mp4,mkv,mpg) ครั้งละ 1 ไฟล์และขนาดไม่เกิน 100 MB',
};

export const dropZoneImageOption = {
  acceptFile: '.jpg,.png,.jpeg',
  maxSize: 100,
  limitationText:
    'สามารถอัพโหลดไฟล์นามสกุล (.jpg,.png,.jpeg) ครั้งละ 1 ไฟล์และขนาดไม่เกิน 100 MB',
};

class MediaPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isUploading: false,
      nameState: '',
      urlState: '',
      thumbnails: [],
      thumbnail: ''
    };
    this.submitClick = this.submitClick.bind(this);
    this.backClick = this.backClick.bind(this);
    this.downloadThumb = this.downloadThumb.bind(this);
    this.downloadVDO = this.downloadVDO.bind(this);
  }

  downloadThumb = async (thumbnails, url) => {
    await this.props.media.downloadThumb(JSON.stringify(thumbnails), url);
  }

  downloadVDO = async (api, url) => {
    await this.props.media.downloadVDO(api, url);
  }

  async componentDidMount() {
    const id = this.props.match.params.id;
    const task = this.props.match.params.task;
    try {
      await this.props.category.loadCategories();
      if (id) {
        await this.props.media.resetMedia();
        const media = await this.props.media.getMedia(id, task);
        this.setState({
          thumbnails: media.thumbnails,
        });
        this.setState({
          thumbnail: media.thumbnail,
        });
        this.setState({
          isUploading: false,
          nameState: 'success',
          urlState: 'success',
        });
      } else {
        await this.props.media.resetMedia();
      }
    } catch (error) {
      Swal.fire({
        type: 'error',
        title: 'Sorry!',
        text: error
      });
    }
  }

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  verifyNumber(value) {
    var numberRex = new RegExp('^[0-9]+$');
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  change(event, stateName, type, stateNameEqualTo, maxValue) {
    if (
      event.target.name !== 'password' && event.target.name !== 'confirmPassword'
    ) {
      if (event.target.name === 'status') {
        this.props.media.changeFieldMedia(
          event.target.name,
          event.target.checked ? 'active' : 'in_active',
        );
      } else {
        this.props.media.changeFieldMedia(event.target.name, event.target.value);
      }
    } else {
      this.props.media.changeFieldMedia(event.target.name, event.target.value);
      this.setState({ [stateName]: event.target.value });
    }
    switch (type) {
      case 'checkbox':
        if (event.target.checked) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'number':
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'length':
        if (this.verifyLength(event.target.value, stateNameEqualTo)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'max-length':
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'min-value':
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'max-value':
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      case 'range':
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + 'State']: 'success' });
        } else {
          this.setState({ [stateName + 'State']: 'error' });
        }
        break;
      default:
        break;
    }
  }

  printError(code) {
    let message = 'ไม่สามารถบันทึกข้อมูลได้';
    switch (code) {
      case 'validation_failed':
        message = 'กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน';
        break;
      case 'data_not_found':
        message = 'ไม่พบข้อมูล';
        break;
      default:
        break;
    }
    return message;
  }

  validationForm() {
    let statusValidation = true;
    if (this.state.nameState === '') {
      this.setState({ nameState: 'error' });
      statusValidation = false;
    }
    return statusValidation;
  }

  async updateMedia() {
    if (this.validationForm()) {
      let { mode } = this.props.media;
      let id = this.props.match.params.id;
      if (id && mode === 'edit') {
        try {
          await this.props.media.updateMedia(id);
          Swal.fire({
            type: 'success',
            title: 'Success!',
            text: 'Update media success',
          }).then(result => {
            if (result.value) {
              this.props.history.goBack();
              // this.props.history.push(`/admin/media`);
            }
          });
        } catch (error) {
          Swal.fire({
            type: 'error',
            title: 'Sorry!',
            text: error,
          });
        }
      } else {
        try {
          await this.props.media.createMedia();
          Swal.fire({
            type: 'success',
            title: 'Success!',
            text: 'Create media success',
          }).then(result => {
            if (result.value) {
              this.props.history.push(`/admin/media`);
            }
          });
        } catch (error) {
          Swal.fire({
            type: 'error',
            title: 'Sorry!',
            text: error,
          });
        }
      }
    }
  }

  onUpload = () => {
    let { media } = this.props.media;
    if (media.url !== '' && media.url) {
      Swal.fire({
        type: 'warning',
        title: 'Warning !',
        text: 'กรุณาลบไฟล์เดิมก่อน',
      });
    } else {
      this.setState({ isUploading: true }, () => {
        this.setState({ loading: true });
        this.dropZone.upload();
      });
    }
  };

  onUploadComplete = async files => {
    this.setState({ loading: false });
    let { media } = this.props.media;
    const url = files[0].res.url;
    const dataName = files[0].res.data_name;
    const thumbnails = files[0].res.thumbnails;
    if (thumbnails && thumbnails.length > 0) {
      this.setState({
        thumbnails
      })
      this.props.media.changeFieldMedia('thumbnails', thumbnails);
      this.setState({
        thumbnail: thumbnails[0]
      });
      this.props.media.changeFieldMedia('thumbnail', thumbnails[0]);
    }
    if (dataName && dataName.length === 3) {
      if (!media.name && !media.startDate) {
        this.setState({
          nameState: 'success'
        });
        const year = dataName[0].substr(0, 4);
        const month = dataName[0].substr(4, 2);
        const day = dataName[0].substr(6, 2);
        const date = year + '-' + month + '-' + day + 'T00:00:00Z';
        this.props.media.changeFieldMedia('startDate', new Date(date));
        this.props.media.changeFieldMedia('name', dataName[1]);
      }
    }
    this.setState({ isUploading: false });
    this.props.media.changeFieldMedia('url', url);
  };

  handleRemove = () => {
    this.props.media.changeFieldMedia('url', '');
  }

  handleMultiple = event => {
    this.props.media.changeCategorySelect(event.target.value);
  };

  handleTags = regularTags => {
    this.props.media.changeFieldMedia('tags', regularTags);
  };

  handleRemoveThumbnail = () => {
    this.props.media.changeFieldMedia('thumbnail', '');
  }

  backClick() {
    this.props.history.goBack();
  }

  async submitClick() {
    if (this.validationForm()) {
      await this.updateMedia();
    }
  }

  handleStartDateChange = date => {
    this.props.media.changeFieldMedia('startDate', new Date(date));
  };

  imageClick = source => {
    this.setState({ thumbnail: source });
    this.props.media.changeFieldMedia('thumbnail', source);
  }


  render() {
    const { classes } = this.props;
    let { media, mode, categorySelect, loading } = this.props.media;
    const fileName = media.url.replace('https://s3-ap-southeast-1.amazonaws.com/nw-fast-media/media/', '');
    let { categories } = this.props.category;
    return (
      <div>
        <Loader
          loading={this.state.loading || loading}
        />
        <GridContainer>
          <GridItem xs={12} sm={12} md={media.url ? 12 : 6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <VideoCallIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Video</h4>
              </CardHeader>
              <CardBody>
                {mode === 'view' ?
                  <GridContainer>
                    <GridItem xs={12}>
                      <PreviewVideo
                        removeButton={false}
                        imageProps={media.url}
                        handleRemove={this.handleRemove}
                      />
                    </GridItem>
                  </GridContainer>
                  :
                  <GridContainer>
                    <GridItem xs={12} md={5} sm={5}>
                      <DropZone
                        ref={e => {
                          this.dropZone = e;
                        }}
                        placeholder="Click here to upload a video."
                        url={`${config.api.url}/uploads`}
                        acceptedFiles={dropZoneVideoOption.acceptFile}
                        maxFileSize={dropZoneVideoOption.maxSize}
                        dirName="media"
                        // fileName=""
                        onAllComplete={this.onUploadComplete}
                      />
                      <Button fullWidth color="primary" onClick={this.onUpload}>Upload Video</Button>
                    </GridItem>
                    <GridItem xs={12} md={7} sm={7}>
                      <PreviewVideo
                        removeButton={true}
                        imageProps={media.url}
                        handleRemove={this.handleRemove}
                      />
                    </GridItem>
                  </GridContainer>
                }

              </CardBody>
            </Card>


          </GridItem>
          <GridItem xs={12} sm={12} md={media.url ? 12 : 6}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <BurstModeIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Thumbnail</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} md={12} sm={12}>
                    <GridList className={classes.gridList} cols={3.5}>

                      {mode === 'view' ?
                        (this.state.thumbnails || []).map(tile => (
                          <GridListTile key={tile}>
                            <img src={tile} alt='...' />
                          </GridListTile>
                        ))
                        :
                        (this.state.thumbnails || []).map(tile => (
                          <GridListTile key={tile}>
                            <img onClick={(e) => this.imageClick(tile)} src={tile} alt='...' />
                            {tile === this.state.thumbnail && <GridListTileBar
                              title={'selected Thumbnail'}
                              classes={{
                                root: classes.titleBar,
                                title: classes.title,
                              }}
                              actionIcon={
                                <IconButton aria-label={`star Thumbnail`}>
                                  <StarBorderIcon className={classes.title} />
                                </IconButton>
                              }
                            />}
                          </GridListTile>
                        ))
                      }

                    </GridList>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="primary" text>
                <CardText color="primary">
                  <h4 className={classes.cardTitle}>
                    {'Info'}
                  </h4>
                </CardText>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={2}>
                      <FormLabel className={classes.labelHorizontal}>
                        Title
                    </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={8}>
                      <CustomInput
                        success={this.state.nameState === 'success'}
                        error={this.state.nameState === 'error'}
                        id="name"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        disabled={mode === 'view' ? true : false}
                        inputProps={{
                          onChange: event =>
                            this.change(event, 'name', 'length', 3),
                          type: 'text',
                          value: `${media.name || ''}`,
                          name: 'name',
                          endAdornment:
                            this.state.nameState === 'error' ? (
                              <InputAdornment position="end">
                                <Close className={classes.danger} />
                              </InputAdornment>
                            ) : (
                                undefined
                              ),
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={2}>
                      <FormLabel className={classes.labelHorizontal}>
                        Category
                    </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={8}>
                      <FormControl
                        fullWidth
                        className={classes.selectFormControl}
                      >
                        <InputLabel
                          htmlFor="multiple-select"
                          className={classes.selectLabel}
                        >
                          Choose Category
                          </InputLabel>
                        <Select
                          disabled={mode === 'view' ? true : false}
                          multiple
                          value={categorySelect}
                          onChange={this.handleMultiple}
                          MenuProps={{ className: classes.selectMenu }}
                          classes={{ select: classes.select }}
                          inputProps={{
                            name: "category",
                            id: "category"
                          }}
                        >
                          {categories.map((category) =>
                            <MenuItem
                              key={category.id}
                              classes={{
                                root: classes.selectMenuItem,
                                selected: classes.selectMenuItemSelectedMultiple
                              }}
                              value={category.id}
                            >
                              {category.name}
                            </MenuItem>
                          )
                          }
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  {mode !== 'view' &&
                    <GridContainer>
                      <GridItem xs={12} sm={2}>
                        <FormLabel className={classes.labelHorizontal}>
                          Tags
                  </FormLabel>
                      </GridItem>
                      <GridItem xs={12} sm={8}>
                        <div style={{ marginTop: '30px' }}>
                          {media.tags && <TagsInput
                            value={media.tags}
                            onChange={this.handleTags}
                            tagProps={{ className: "react-tagsinput-tag info" }}
                          />}

                        </div>
                      </GridItem>
                    </GridContainer>
                  }
                  <GridContainer>
                    <GridItem xs={12} sm={2}>
                      <FormLabel className={classes.labelHorizontal}>
                        OnAir
                    </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={8}>

                      {mode === 'view' ?
                        <CustomInput
                          id="onair"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          disabled={true}
                          inputProps={{
                            type: 'text',
                            value: `${moment(media.startDate).tz('Asia/Bangkok').format('DD/MM/YYYY') || ''}`,
                            name: 'onair'
                          }}
                        />
                        :
                        <div style={{ marginTop: '30px' }}>
                          <Datetime
                            // timeFormat={false}
                            value={moment(media.startDate).tz('Asia/Bangkok').format('DD/MM/YYYY') || ''}
                            onChange={this.handleStartDateChange}
                            // onChange={this.handleDateTime}
                            inputProps={{ placeholder: "Datetime Picker Here" }}
                          />
                        </div>
                      }
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
              <CardFooter className={classes.justifyContentRight}>
                <Button onClick={this.backClick} style={{ marginRight: '5px' }}>
                  Back
              </Button>
                {mode !== 'view' ?
                  <Button color="primary" onClick={this.submitClick}>
                    {mode === 'edit' ? 'Save' : 'Submit'}
                  </Button>
                  :
                  <div>
                    <Button color="success" onClick={e => this.downloadVDO(`${config.s3.url}/api/files/${fileName}`, media.url)}>
                      {'Download VDO'}
                    </Button>
                    <Button color="primary" onClick={e => this.downloadThumb(media.thumbnails, media.url)}>
                      {'Download Thumbnails'}
                    </Button>
                  </div>
                }
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer >
      </div>
    );
  }
}

MediaPage.propTypes = {
  classes: PropTypes.object,
};

export const page = inject('media', 'category')(observer(MediaPage));
export default withStyles(styles)(page);
